const scenarioActionTypes = {
    GET_TREE_DATA: 'GET_TREE_DATA',
    UPDATE_EDITING_USERS: 'UPDATE_EDITING_USERS',
    TREE_DATA: 'TREE_DATA',
    ADD_NODE: 'ADD_NODE',
    UPDATE_NODE: 'UPDATE_NODE',
    DELETE_NODE: 'DELETE_NODE',
    CHANGE_NODE_TO_PORTAL: 'CHANGE_TO_PORTAL',
    WIRE_PORTAL_TO_SOURCE: 'WIRE_PORTAL_TO_SOURCE',
    MAKE_PORTAL_SOURCE: 'MAKE_PORTAL_SOURCE',
    CHANGE_LINK_TO_PORTAL: 'CHANGE_LINK_TO_PORTAL',
    ADD_LINK: 'ADD_LINK',
    DELETE_LINK: 'DELETE_LINK',
    SCENARIO: 'SCENARIO',
    SCENARIO_SETTING: 'SCENARIO_SETTING',
    EDITING_USER_LIST: 'EDITING_USER_LIST',
    EDITING_USER: 'EDITING_USER',
    CREATE_EDITING_USER: 'CREATE_EDITING_USER',
    EXCEPTION: 'EXCEPTION',
    EXCEPTION_MAP: 'EXCEPTION_MAP',
    TOGGLE_EXCEPTION: 'TOGGLE_EXCEPTION',
    INCREASE_SAVING_COUNT: 'INCREASE_SAVING_COUNT',
    DECREASE_SAVING_COUNT: 'DECREASE_SAVING_COUNT',
    MOVE_NODE: 'MOVE_NODE',
    VARIABLE: 'VARIABLE',
    GET_VARIABLE: 'GET_VARIABLE',
    GLOBAL_SETTING: 'GLOBAL_SETTING',
    GET_GLOBAL_SETTING: 'GET_GLOBAL_SETTING',
    DICTIONARY_TTS: 'DICTIONARY_TTS',
    GET_DICTIONARY_TTS: 'GET_DICTIONARY_TTS',

    // nlp
    INTENT_LIST: 'INTENT_LIST',
    ENTITY_LIST: 'ENTITY_LIST',
    SAMPLE_LIST: 'SAMPLE_LIST',
    KEYWORD_LIST: 'KEYWORD_LIST',
    DICTIONARY_LIST: 'DICTIONARY_LIST',
    GET_INTENT_LIST: 'GET_INTENT_LIST',
    GET_ENTITY_LIST: 'GET_ENTITY_LIST',
    GET_SAMPLE_LIST: 'GET_SAMPLE_LIST',
    GET_KEYWORD_LIST: 'GET_KEYWORD_LIST',
    GET_DICTIONARY_LIST: 'GET_DICTIONARY_LIST',
    GET_NLP: 'GET_NLP',
    CLEAR_NLP: 'CLEAR_NLP',
    NODE_SETTING_VARIABLE: 'NODE_SETTING_VARIABLE',
    GET_NODE_SETTING_VARIABLE_LIST: 'GET_NODE_SETTING_VARIABLE_LIST',
    SCENARIO_AUDIO: 'SCENARIO_AUDIO',
    GET_SCENARIO_AUDIO: 'GET_SCENARIO_AUDIO',

    //kb setting
    KB_SETTING: 'KB_SETTING',
    GET_KB_SETTING: 'GET_KB_SETTING',

    //audio engine
    AUDIO_ENGINE: 'AUDIO_ENGINE',
    GET_AUDIO_ENGINE: 'GET_AUDIO_ENGINE',

    //llm
    USE_GUARDRAIL: 'USE_GUARDRAIL',
    LLM_CLASSIFIER: 'LLM_CLASSIFIER',
    GET_LLM_CLASSIFIER: 'GET_LLM_CLASSIFIER',
    LLM_RESPONSE: 'LLM_RESPONSE',
    GET_LLM_RESPONSE: 'GET_LLM_RESPONSE',
    LLM_CONFIGS: 'LLM_CONFIGS',
    GET_LLM_CONFIGS: 'GET_LLM_CONFIGS',
    ALLOWED_LLM_CONFIGS: 'ALLOWED_LLM_CONFIGS',

    // lua global
    GLOBAL_LUA: 'GLOBAL_LUA',
    GET_GLOBAL_LUA: 'GET_GLOBAL_LUA',

    // tenant name
    TENANT_NAME: 'TENANT_NAME',
}

export default scenarioActionTypes
